export const handleShare = async (link) => {
    if (navigator.share) {
        try {
            await navigator.share({
                title: "H N Store",
                text: "Shop trusted products at H N Store – check out this one!",
                url: link, // current page link
            });
            console.log("Shared successfully!");
        } catch (error) {
            console.error("Error sharing:", error);
        }
    } else {
        alert("Sharing not supported in this browser.");
    }
};